export const ACCOUNT_SWITCH_TOOLTIP_SESSION_STORAGE_KEY = 'isAccountSwitchTooltipVisible'
